import { useEffect, useState } from "react";
import { api } from "../../lib/apiClient";
import { PageHead, Card, Pill, Loading, Err } from "./_shared";

export default function FeatureFlags() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");

  const load = () => api.get("/api/admin/feature-flags").then((d) => setItems(d.items)).catch((e) => setErr(e.message));
  useEffect(() => { load(); }, []);

  const toggle = async (feature_key, enabled) => {
    try {
      await api.patch("/api/admin/feature-flags", { feature_key, enabled });
      await load();
    } catch (e) { setErr(e.message); }
  };

  if (err) return <Err msg={err} />;
  if (!items) return <Loading />;

  const env = items[0]?.environment || "local";

  return (
    <div data-testid="admin-feature-flags">
      <PageHead title="Feature flags" sub={`Global · environment ${env}`} right={<Pill tone="aqua">{items.length} flags</Pill>} />
      <div style={{ marginTop: 4, padding: 12, borderRadius: 10, background: "rgba(39,230,209,0.06)", border: "1px solid rgba(39,230,209,0.22)", fontSize: 12, color: "var(--pl-text-muted)", marginBottom: 18 }}>
        Toggles here affect the entire platform. Workspace-level overrides take precedence and are managed inside each workspace’s detail page.
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: 12 }}>
        {items.map((f) => (
          <Card key={f.feature_key}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10 }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 800 }}>{f.feature_key.replace(/_/g, " ")}</div>
                <div style={{ fontSize: 11, color: "var(--pl-text-muted)", marginTop: 4, lineHeight: 1.5 }}>
                  {f.description || "—"}
                </div>
              </div>
              <Toggle data-testid={`flag-${f.feature_key}`} checked={!!f.enabled}
                onChange={(v) => toggle(f.feature_key, v)} />
            </div>
            <div style={{ marginTop: 12, display: "flex", gap: 8, alignItems: "center" }}>
              <Pill tone={f.enabled ? "success" : "muted"}>{f.enabled ? "enabled" : "disabled"}</Pill>
              <Pill>rollout {f.rollout_percentage ?? 100}%</Pill>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

function Toggle({ checked, onChange, "data-testid": dt }) {
  return (
    <button type="button" data-testid={dt} onClick={() => onChange(!checked)} style={{
      width: 42, height: 24, borderRadius: 999, border: 0, padding: 0, cursor: "pointer",
      background: checked ? "linear-gradient(135deg, var(--pl-aqua), #B9FF2F)" : "var(--pl-bg-2)",
      position: "relative", transition: "background 160ms",
    }}>
      <span style={{
        position: "absolute", top: 2, left: checked ? 20 : 2, width: 20, height: 20, borderRadius: 999,
        background: "#0a1816", transition: "left 160ms",
        boxShadow: "0 1px 4px rgba(0,0,0,0.6)",
      }} />
    </button>
  );
}
